<template>
    <div
        data-testid="lettr-promo-banner-v2"
        class="flex items-center gap-3 border-b border-border bg-muted px-4 py-3"
    >
        <img :src="LETTR_LOGO" class="size-5 shrink-0" alt="" />

        <div class="flex-1 text-sm">
            <span class="font-medium text-primary">
                Send a template with one API call.
            </span>
            <span class="text-muted-foreground">
                Lettr is an email platform built for SaaS: REST or SMTP,
                webhooks per event, searchable logs, deliverability managed.
            </span>
        </div>

        <div class="flex shrink-0 items-center gap-2">
            <!-- Not "Connect": there is no integrations page and no templates
                 in the plugin app, so there is nothing here to connect it to. -->
            <Button size="sm" @click="learnMore('lettr_banner_v2')">
                See how it works
            </Button>

            <Button
                variant="ghost"
                size="icon"
                class="size-8 text-muted-foreground hover:text-primary"
                data-testid="lettr-promo-banner-v2-dismiss"
                @click="dismiss('lettr_banner')"
            >
                <X class="size-4" />
            </Button>
        </div>
    </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { X } from 'lucide-vue-next';
import { Button } from '@/components/ui/button';
import useLettrPromo, { LETTR_LOGO } from '@/composables/useLettrPromo';

const { trackImpression, dismiss, learnMore } = useLettrPromo();

onMounted(() => {
    trackImpression('lettr_banner_v2');
});
</script>
